<template>
    <v-container class="my-event-list" fluid>
        <v-row>
            <v-col cols="12" md="6">
                <v-select :label="$t('my_event_list.year')"
                          :items="yearOptions"
                          v-model="selectedYear"></v-select>
            </v-col>
            <v-col cols="12" md="6">
                <v-select :label="$t('my_event_list.category')"
                          :items="categoryOptions"
                          v-model="selectedCategory"></v-select>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="p-0">
                <v-data-table :items="filteredEnrollments"
                              :headers="enrollmentHeaders"
                              :loading="enrollments == null"
                              :no-data-text="$t('my_event_list.no_event')"
                              :locale="$i18n.locale"
                              :header-props="{ sortByText: $t('sort_by')}"
                              :footer-props="{itemsPerPageOptions: [10, 20, 50], showFirstLastPage: true, itemsPerPageText: $t('row_per_page')}">
                    <template v-slot:item.create_at="{value}">
                        {{DateTime.fromISO(value).toFormat('yyyy-MM-dd')}}
                    </template>
                    <template v-slot:item.event="{item}">
                        {{$sanitizeHtml(item.event.name)}}
                    </template>
                    <template v-slot:item.status="{item}">
                        {{enrollmentStatusLabel(item)}}
                    </template>
                    <template v-slot:item.actions="{item}">
                        <v-btn icon color="primary"
                               :to="{name: 'my-event-detail', params: {enrollmentId: item.id}}">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn icon color="primary"
                                       v-if="eventNeedPayment(item)"
                                       v-on="on"
                                       @click="showPayEventDialog(item)"
                                       class="ml-3">
                                    <v-icon>mdi-currency-usd</v-icon>

                                </v-btn>
                            </template>
                            {{$t('my_event_list.pay')}}
                        </v-tooltip>

                        <v-btn color="primary"
                               v-if="surveyAvailable(item)"
                               @click="startSurvey(item)"
                               class="ml-3">
                            <v-icon>mdi-format-list-bulleted-square</v-icon>
                            {{$t('my_event_list.start_survey')}}
                        </v-btn>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <v-dialog v-model="payEventDialogShown">
            <v-card light
                    class="event-pay-dialog"
                    v-if="payingEnrollment"
                    min-width="50vw">
                <v-card-text>
                    <v-container fluid>
                        <v-row>
                            <v-col>
                                <v-text-field readonly
                                              hide-details
                                              :label="$t('my_event_list.pay_amount')"
                                              :value="payingEventPayingAmount"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="12"
                                   :class="['event-pay-dialog-payment-method', {'active': paymentMethod === 'cyber_source'}]"
                                   @click="paymentMethod = 'cyber_source'">
                                <v-img class="event-pay-dialog-payment-method-logo"
                                       :src="require('../../../assets/logo-credit-cards.png')"
                                       height="64px"></v-img>
                            </v-col>
<!--                            <v-col cols="1" v-if="$vuetify.breakpoint.mdAndUp"></v-col>-->
<!--                            <v-col cols="12" md="4"-->
<!--                                   :class="['event-pay-dialog-payment-method', {'active': paymentMethod === 'union_pay'}]"-->
<!--                                   @click="paymentMethod = 'union_pay'">-->
<!--                                <v-img class="event-pay-dialog-payment-method-logo"-->
<!--                                       :src="require('../../../assets/logo-union-pay.png')"-->
<!--                                       height="64px"></v-img>-->
<!--                            </v-col>-->
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn text
                           @click="payEventDialogShown = false">
                        {{$t('cancel')}}
                    </v-btn>

                    <v-btn text color="primary"
                           :disabled="!paymentMethod"
                           @click="initEventPayment()">
                        {{$t('my_event_list.pay')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
    import {DateTime} from 'luxon'
    import _ from 'lodash';

    export default {
        name: 'MyEventList',
        components: {},
        data() {
            return {
                enrollments: null,
                enrollmentHeaders: [
                    {text: this.$t('admin_enrollment.enrolled_at'), value: 'create_at'},
                    {text: this.$t('admin_hkiarace.event'), value: 'event'},
                    {text: this.$t('admin_enrollment.status'), value: 'status'},
                    {text: '', value: 'actions'},
                ],
                categories: [],
                completedSurveyIds: [],

                selectedYear: null,
                selectedCategory: null,

                payEventDialogShown: null,
                payingEnrollment: null,
                paymentMethod: null,

                DateTime: DateTime,
            };
        },
        mounted() {
            this.getEnrollments();
            this.getCategories();
            this.getCompletedSurveys();
        },
        watch: {},
        computed: {
            yearOptions() {
                if (this.enrollments == null) {
                    return [];
                }

                let years = [];

                this.enrollments.forEach(function (e) {
                    let start = DateTime.fromISO(e.event.start);
                    if (years.indexOf(start.year) === -1) {
                        years.push(start.year)
                    }
                });

                let options = years.map(function (y) {
                    return {text: y, value: y};
                });

                return _.concat([{text: this.$t('all'), value: null}], options);
            },
            categoryOptions() {
                return _.concat([{text: this.$t('all'), value: null}], this.categories.map(function (c) {
                    return {text: c.name, value: c};
                }))
            },
            filteredEnrollments() {
                if (this.enrollments == null) {
                    return [];
                }

                let enrollments = this.enrollments;

                if (this.selectedYear) {
                    var v = this;
                    enrollments = _.filter(enrollments, function (e) {
                        let start = DateTime.fromISO(e.event.start);

                        return start.year === v.selectedYear;
                    })
                }

                if (this.selectedCategory) {
                    var v = this;
                    enrollments = _.filter(enrollments, function (e) {
                        return e.event.category.id === v.selectedCategory.id;
                    })
                }

                return enrollments;
            },
            payingEventPayingAmount() {
                if (!this.payingEnrollment) {
                    return 0;
                }

                let feeTiers = JSON.parse(this.payingEnrollment.event.fee_tiers || '[]');

                if (feeTiers.length === 0) {
                    return 0;
                } else if (!feeTiers[0].name_en) {
                    return feeTiers[0].fee;
                } else {
                    let total = 0;
                    let meta = JSON.parse(this.payingEnrollment.meta);

                    feeTiers.forEach((f) => {
                        if (meta[f.id]) {
                            total += meta[f.id] * f.fee;
                        }
                    });

                    return total;
                }
            },
        },
        methods: {
            getEnrollments() {
                this.$callAPI('hkiarace/event/my_enrollment/', {}, function (response) {
                    this.enrollments = response.body.enrollments;
                })
            },
            getCategories() {
                this.$callAPI('hkiarace/event_category/', {}, function (response) {
                    this.categories = response.body.categories;
                })
            },
            getCompletedSurveys() {
                this.$callAPI('hkiarace/event/survey/completed/', {}, function (response) {
                    this.completedSurveyIds = response.body.surveys;
                })
            },
            paymentSuccess(paymentRecord) {
                let paymentSuccess = false;
                if (paymentRecord.payment_record.payment_method === 'cyber_source') {
                    paymentRecord.payment_record.cyber_source_payment_records.forEach((r) => {
                        if (r.decision === 'ACCEPT') {
                            paymentSuccess = true;
                        }
                    })
                } else if (paymentRecord.payment_record.payment_method === 'union_pay') {
                    paymentRecord.payment_record.union_pay_payment_records.forEach((r) => {
                        if (r.response_code === '00') {
                            paymentSuccess = true;
                        }
                    })
                }

                return paymentSuccess;
            },
            eventNeedPayment(enrollment) {
                let v = this;
                if (JSON.parse(enrollment.event.fee_tiers || '[]').length === 0) {
                    return false;
                }

                if (enrollment.status !== 1) {
                    return false;
                }

                let paid = false;

                enrollment.participation.forEach((r)=> {
                  if (r.paid_at) paid = true;
                })

                enrollment.hkiarace_event_payment_records.forEach((r) => {
                    if (v.paymentSuccess(r)) {
                        paid = true;
                    }
                });
                return !paid;
            },
            enrollmentStatusLabel(enrollment) {
                if (this.eventNeedPayment(enrollment)) {
                    return this.$t('enrollment_status.pending_payment');
                }

                return {
                    '0': this.$t('enrollment_status.pending'),
                    '1': this.$t('enrollment_status.accepted'),
                    '-1': this.$t('enrollment_status.rejected'),
                }[enrollment.status];
            },
            toggleEnrollmentDetail(enrollment) {
                this.$root.$emit('bv::toggle::collapse', 'collapse-' + enrollment.id);
            },
            surveyAvailable(enrollment) {
                return this.completedSurveyIds.indexOf(enrollment.event.id) === -1 && enrollment.event.survey_enabled;
            },
            startSurvey(enrollment) {
                this.$callAPI('hkiarace/event/survey/', {event_id: enrollment.event.id}, function (response) {
                    this.$router.push({name: 'survey', params: {responseId: response.body.response_id}});
                })
            },
            showPayEventDialog(enrollment) {
                this.payingEnrollment = enrollment;
                this.payEventDialogShown = true;
            },
            initEventPayment() {
                if (this.payingEnrollment && confirm(this.$t('booking_preview.redirect_warning'))) {
                    this.$callAPI('hkiarace/event/init_payment/', {
                        enrollment_id: this.payingEnrollment.id,
                        payment_method: this.paymentMethod
                    }, function (response) {
                        this.postForm(response.body.url, response.body.params)
                    });
                }
            },
            postForm(path, params, method = 'post') {
                const form = document.createElement('form');
                form.method = method;
                form.action = path;

                for (const key in params) {
                    if (params.hasOwnProperty(key)) {
                        const hiddenField = document.createElement('input');
                        hiddenField.type = 'hidden';
                        hiddenField.name = key;
                        hiddenField.value = params[key];

                        form.appendChild(hiddenField);
                    }
                }

                document.body.appendChild(form);
                form.submit();
                this.$startLoading();
            }
        }
    }
</script>

<style lang="less">
    .my-event-list {
        text-align: left;
        padding: 24px;

        .my-event-list-title {
            font-weight: bold;
            font-size: 1.3rem;
        }

        .my-event-list-empty {
            color: #444;
            font-size: 2rem;
        }

        .my-event-list-cell {
            padding: 30px;
            background-color: #f8f9fc;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .event-name {
                padding-right: 10px;
                width: calc(100% - 150px);
            }

            .category-label {
                text-align: center;
                color: white;
                border-radius: 30px;
                padding: 10px;
                width: 150px;
                height: fit-content;
            }
        }

        .my-event-list-detail {
            padding: 15px;

            .my-event-list-detail-event-name {
                font-weight: bold;
                font-size: 1.5rem;
            }
        }

        .event-pay-dialog {

            .v-label {
                color: #8E765B;
            }

            .v-input--is-readonly > .v-input__control > .v-input__slot:before {
                display: none;
            }

            .v-input--is-readonly > .v-input__control > .v-input__slot:after {
                display: none;
            }

            .event-pay-dialog-payment-method {
                border: 2px solid rgba(0, 0, 0, 0.2);
                cursor: pointer;

                &:hover, &.active {
                    border-color: #8E765B;
                }

                .event-pay-dialog-payment-method-logo {

                }
            }
        }
    }
</style>
